import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';

import { FavoritesList, FavoritesSearchParams, Stream, StreamStatus } from '@kitch/data-access/models';
import { StreamsService, TokenService } from '@kitch/data-access/services';

@Component({
  selector: 'app-favorites-upcoming',
  templateUrl: './favorites-upcoming.component.html',
  styleUrls: ['./favorites-upcoming.component.scss', './../favorites-shared.scss'],
})
export class FavoritesUpcomingComponent implements OnInit {
  favoritesStreams: Stream[];
  purchasedStreams: Stream[];
  isLoading: boolean;
  profileId: string;

  constructor(
    private streamsService: StreamsService,
    private route: ActivatedRoute,
    private tokenService: TokenService,
  ) {}

  ngOnInit(): void {
    this.profileId = this.tokenService.getProfileId();

    this.getFavoritesUpcomingStreams().subscribe();
  }

  private getFavoritesUpcomingStreams(): Observable<FavoritesList<Stream>> {
    this.isLoading = true;
    const upcomingStreamsParams: FavoritesSearchParams = {
      status: StreamStatus.SCHEDULED,
      profileId: this.profileId,
    };

    return this.streamsService.getFavoritedStreams(upcomingStreamsParams).pipe(
      tap((streams) => {
        this.favoritesStreams = streams.results.map(stream => {
          stream.channel = {
            // we receive different data structure for ordinary stream and favorited one
            // in future we should make them similar either on the back-end or in stream service
            // this fix is temporary
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            chefProfile: stream.profile,
          };

          return stream;
        });
        this.purchasedStreams = streams.purchasedResults;
      }),
      finalize(() => this.isLoading = false),
    );
  }
}
